import {
  individualGroupProfileConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { individualGroupProfileService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const {
  GROUP_DETAIL,
  STORES_BY_GROUP_ID,
  PAGINATED_GROUPS_DATA,
  GET_STORES_BY_GROUPS_IDS,
} = individualGroupProfileConstants;

//Fetching group details
const getGroupDetails = (groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, GROUP_DETAIL, () =>
      individualGroupProfileService
        .getGroupDetails(groupId)
        .then(
          (response) => {
            dispatch(success(response || [], GROUP_DETAIL));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getBrandLocationsByGroupId = (groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, STORES_BY_GROUP_ID, () =>
      individualGroupProfileService
        .getBrandLocationsByGroupId(groupId)
        .then(
          (response) => {
            dispatch(success(response, STORES_BY_GROUP_ID));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getBrandLocationsByGroupsIds = (groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_STORES_BY_GROUPS_IDS, () =>
      individualGroupProfileService
        .getBrandLocationsByGroupsIds(groupId)
        .then(
          (response) => {
            dispatch(success(response, STORES_BY_GROUP_ID));
          },
          (error) => {
            dispatch(failure([], STORES_BY_GROUP_ID));
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Fetching paginated group details
const getGroupPaginatedDetails = (body, groupId) => {
  return (dispatch) => {
    withSpinner(dispatch, PAGINATED_GROUPS_DATA, () =>
      individualGroupProfileService
        .getGroupPaginatedDetails(body, groupId)
        .then(
          (response) => {
            dispatch(success(response, PAGINATED_GROUPS_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Exporting functions for other files
export const individualGroupProfileActions = {
  getGroupDetails,
  getGroupPaginatedDetails,
  getBrandLocationsByGroupId,
  getBrandLocationsByGroupsIds,
};
